import React from "react";
import i18n from "../lang/i18n";
import Icon from "@mdi/react";
import {mdiTimer} from "@mdi/js";
import {toHoursAndMinutes} from "../Helper";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({Min, isTotal = false}: {Min: number, isTotal?: boolean}) => {
    return (
        <div className="text-light">
            {isTotal && <span>{i18n.t('425')}:</span>}
            <Icon path={mdiTimer} size={1}/>
            <span>{toHoursAndMinutes(Min)}</span>
        </div>
    );
}